<template>
  <div class="pdf" v-show="fileType === 'pdf'">
    <p class="arrow">
    
    <el-button type="primary"  size="mini" @click="changePdfPage(0)" class="turn" :class="{grey: currentPage==1}" icon="el-icon-arrow-left">上一页</el-button>
    {{currentPage}} / {{pageCount}}
    <el-button type="primary"  size="mini" @click="changePdfPage(1)" class="turn" :class="{grey: currentPage==pageCount}">下一页<i class="el-icon-arrow-right el-icon--right"></i></el-button>
    </p>
    <pdf
      v-loading="loading"
      element-loading-text="正在加载中，请稍候..."
      element-loading-spinner="el-icon-loading"
      :src="src"
      :page="currentPage" 
      @num-pages="pageCount=$event" 
      @page-loaded="currentPage=$event" 
      @loaded="loadPdfHandler"> 
    </pdf>
  </div>
</template>

<script>
import pdf from 'vue-pdf'
  export default {
    components: {pdf},
    data () {
      return {
        currentPage: 0, // pdf文件页码
        pageCount: 0, // pdf文件总页数
        fileType: 'pdf', // 文件类型　　　　　
        src: '', // pdf文件地址
        loading: true

      }
    },
    created() {// 有时PDF文件地址会出现跨域的情况,这里最好处理一下　　　　
        this.src = `/uploads/pdf/${this.$route.query.code}.pdf`;
        this.src = pdf.createLoadingTask(this.src)
    },
    methods: {
      // 改变PDF页码,val传过来区分上一页下一页的值,0上一页,1下一页
      changePdfPage (val) {
        // console.log(val)
        if (val === 0 && this.currentPage > 1) {
          this.currentPage--
          // console.log(this.currentPage)
        }
        if (val === 1 && this.currentPage < this.pageCount) {
          this.currentPage++
          // console.log(this.currentPage)
        }
      },
      // pdf加载时
      loadPdfHandler (e) {
        this.loading = false;
        this.currentPage = 1 // 加载的时候先加载第一页
      }

    }
  }

</script>
<style scoped>
.turn{
    font-size:24px;
    
}
</style>